export interface RequiresLocationBeforeCourtsInput {
  hasMultiLocation: boolean;
  locationsLoading: boolean;
  locationCount: number;
  courtCount: number;
}

/**
 * Whether the courts UI should block on "add a location first".
 *
 * Multi-location (Professional+) encourages locations before the first court, but courts
 * created on Starter without locations must remain visible after upgrade.
 */
export function requiresLocationBeforeCourts(input: RequiresLocationBeforeCourtsInput): boolean {
  const { hasMultiLocation, locationsLoading, locationCount, courtCount } = input;
  return hasMultiLocation && !locationsLoading && locationCount === 0 && courtCount === 0;
}
